






import { Component, Vue} from 'vue-property-decorator';
import {
  AcgnLinkDetail
} from '@/components/statistic-detail/components';
import { Tabs, TabPane } from 'element-ui';
import { AcgnStaticsMenu } from '@/components';
import { RenderMenuMixin } from '@/mixins';
@Component({
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    AcgnLinkDetail,
    AcgnStaticsMenu
  },
   mixins: [RenderMenuMixin]
})

/**
 * 项目明细-管理方
 */
export default class AcgnStatisticLinks extends Vue {
  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic"></acgn-statics-menu>
    );
  }
}
